/* eslint-disable*/
// src/mixins/clickMixin.js
import * as Swal from "sweetalert2";
var card = null;
const STRIPE_PUBLIC_KEY =
  "pk_live_51IDz5vKcJ3VN9i5zlXXn0wgNLCL37PNRivB6uAdQf61RhJgajgT3c9lgvKxSjWVPqB3O5ivkajhS1Pb28mi427Ep0022BuxPwy";
const STRIPE_PUBLIC_TEST_KEY =
  "pk_test_51IBHYsDQ6Dx49K3FzPI3tS7L7I7WjQ1VNN4nxiZcblHqVpfsh4i7eqrAXJ71SXXUt1VkLwwoj16Hfoo70NurHwbq00OxGGetxZ";
export default function () {
  return {
    methods: {
      isValidEmailAddress(emailAddress) {
        let pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(emailAddress);
      },
      setPaidBy(status) {
        this.$store.dispatch("generalsettings/setPaidBy", status);
      },
      initCard() {
        let key =
          this.transaction._env == "sandbox"
            ? STRIPE_PUBLIC_TEST_KEY
            : STRIPE_PUBLIC_KEY;
        this.stripe = Stripe(key);
        let VueBox = this;
        var elements = this.stripe.elements();
        var style = {
          base: {
            color: this.getColor(),
            fontFamily: "Arial, sans-serif",
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              //color: this.getColor(),
              color: "#252525",
            },
          },
          invalid: {
            fontFamily: "Arial, sans-serif",
            //color: "#fa755a",
            color: "#b71c1c",
            iconColor: "#b71c1c",
          },
        };
        card = elements.create("card", { hidePostalCode: true, style: style });
        // Stripe injects an iframe into the DOM
        card.mount("#card-element");
        card.on("change", function (event) {
          // Disable the Pay button if there are no card details in the Element
          document.querySelector("button").disabled = event.empty;
          document.querySelector("#card-error").textContent = event.error
            ? event.error.message
            : "";
          VueBox.cardIsValid = !event.error && event.complete;
        });
        var form = document.getElementById("payment-form");
        form.addEventListener("submit", function (event) {
          event.preventDefault();
          // Complete payment when the submit button is clicked
          // payWithCard(stripe, card, data.clientSecret);
        });
      },
      payWithCard() {
        this.submitting = true;
        let VueBox = this;
        let formData = new FormData();
        this.stripe
          .confirmCardPayment(VueBox.client_secret, {
            payment_method: {
              card: card,
            },
          })
          .then(function (result) {
            //console.log('stripe result',result)
            VueBox.submitting = false;
            VueBox.submitted = true;
            if (result.error) {
              VueBox.state = "error";
              VueBox.errors.message = result.error.message;
              VueBox.status = "ERROR";
              formData.append("status", result.error.code);
              formData.append("transaction_id", VueBox.transaction._id);
              formData.append("email", VueBox.email);
              formData.append("first_name", VueBox.first_name);
              formData.append("last_name", VueBox.last_name);
              formData.append("message", result.error.message);
              formData.append("payment_id", result.error.payment_intent.id);
              formData.append(
                "client_secret",
                result.error.payment_intent.client_secret
              );
            } else {
              VueBox.status = "SUCCESS";
              formData.append("status", result.paymentIntent.status);
              formData.append("transaction_id", VueBox.transaction._id);
              formData.append("email", VueBox.email);
              formData.append("first_name", VueBox.first_name);
              formData.append("last_name", VueBox.last_name);
              formData.append("message", "");
              formData.append("payment_id", result.paymentIntent.id);
              formData.append(
                "client_secret",
                result.paymentIntent.client_secret
              );
              if (
                VueBox.transaction.action &&
                VueBox.transaction.action.callback_url
              ) {
                window.location = VueBox.transaction.action.callback_url;
              } else {
                if (window.location !== window.parent.location) {
                  $("#intramModal").css("display", "none");
                }
              }
            }
            VueBox.$store
              .dispatch("payments/updateGateTransaction", formData)
              .then((response) => {})
              .catch((error) => {});
          })
          .catch((error) => {
            console.log("stripe error", error);
            VueBox.submitting = false;
          });
      },

      marchandIsInSandboxMode(transaction) {
        return transaction._env === "sandbox";
        //  return marchand._env==='sandbox'
      },
      getColor() {
        return "#29B3A6";
        //return this.transaction._store.color || "#29B3A6";
      },
      getStatusColor(status) {
        let response = {};
        switch (status) {
          case process.env.VUE_APP_STATUS_ERROR:
            response.color = "red";
            response.status = "échec";
            break;
          case process.env.VUE_APP_STATUS_PENDING:
            response.color = "orange";
            response.status = "en attente";
            break;
          case process.env.VUE_APP_STATUS_SUCCESS:
            response.color = "success";
            response.status = "succès";
            break;
          case "REFUNDED":
            response.color = "indigo";
            response.status = "remboursée";
            break;
          default:
            response.color = "dark";
            response.status = "defaut";
            break;
        }
        return response;
      },
      validate() {
        this.$refs.form.validate();
      },
      reset() {
        this.$refs.form.reset();
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
        this.$refs.form.reset();
      },
      fileChange() {
        this.editedItem._file = this.$refs.file.files[0];
      },
      getFileOriginalName(file) {
        return file.substr(file.lastIndexOf("/") + 1);
      },
      checkIsRoleHasPermission(permissions, data) {
        const found = permissions.some(
          (item) => item._action === data.action && item._entity === data.entity
        );
      },
      checkisDashboard() {
        this.$emit("checkisDashboard", true);
      },
      getDate(value) {
        if (value) {
          let localeCode = JSON.parse(localStorage.getItem("locale")).locale;
          let local = localeCode + "-" + localeCode.toUpperCase();
          return Intl.DateTimeFormat(local, {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
          }).format(new Date(value));
        }
      },
      /* eslint-disable */
      getTransactionRate(type) {
        switch (type) {
          case process.env.VUE_APP_BANQUE: {
            let banqueMean = this.means_of_paiements.find(
              (mean) => mean._type === process.env.VUE_APP_BANQUE
            );
            this.rate = banqueMean._taux;
            this.fees = Math.round(
              this.transaction._amount * (this.rate / 100)
            );
            break;
          }
          case process.env.VUE_APP_MOBILE:
            {
              let marchandCustomRates =
                this.transaction.marchand._settingtransaction;
              let meanMobile = this.getUserMean();
              if (marchandCustomRates.length > 0) {
                let customRateObj = marchandCustomRates.find(
                  (setting) => setting._means_paiement === meanMobile._id
                );
                if (customRateObj) {
                  this.rate = customRateObj._taux;
                  this.fees = Math.round(
                    this.transaction._amount * (this.rate / 100)
                  );
                } else {
                  this.rate = meanMobile._taux;
                  this.fees = Math.round(
                    this.transaction._amount * (this.rate / 100)
                  );
                }
              } else {
                this.rate = meanMobile._taux;
                this.fees = Math.round(
                  this.transaction._amount * (this.rate / 100)
                );
              }
            }
            break;
          default:
            return 0;
        }
      },
      getSettingTransactionRate(id) {
        let marchandCustomRates =
          this.$store.state.settingtransactions.settingtransactions;
        let rate = null;
        for (var i = 0; i < marchandCustomRates.length; i++) {
          if (marchandCustomRates[i]._means_paiement._id == id) {
            rate = marchandCustomRates[i]._means_paiement._taux;
          }
        }
        return rate;
      },
      getCountryMeans() {
        return this.means_of_paiements.filter(
          (mean) =>
            mean._country._code.toLowerCase() ===
            this.country_code.toLowerCase()
        );
      },
      getCountryMobilesMeans() {
        return this.means_of_paiements.filter(
          (mean) =>
            mean._country._code.toLowerCase() ===
              this.country_code.toLowerCase() &&
            mean._type === process.env.VUE_APP_MOBILE
        );
      },
      getCountryBanquesMeans() {
        return this.means_of_paiements.filter(
          (mean) =>
            mean._country._code.toLowerCase() ===
              this.country_code.toLowerCase() &&
            mean._type === process.env.VUE_APP_BANQUE
        );
      },
      getUserMean() {
        let userNumberFirstDigits = this.getUserPhoneNumberFirstDigits();
        let countryMeans = this.getCountryMeans();
        return countryMeans.find((mean) =>
          mean._prefixes.includes(userNumberFirstDigits)
        );
      },
      getUserPhoneNumberFirstDigits() {
        let countryMeans = this.getCountryMobilesMeans();
        let codeStr;
        for (let i = 0; i < countryMeans.length; i++) {
          codeStr = "" + countryMeans[i]._prefixes[0];
          // if (codeStr!==undefined){break}
        }
        let numberOfFirstDigits = codeStr ? codeStr.length : 0;
        return parseInt(this.num_source.substr(0, numberOfFirstDigits));
      },
      getInvoiceTotal(items) {
        let sum = 0;
        items.forEach((item) => {
          let amnt = item.total_amount ? parseInt(item.total_amount) : 0;
          sum += amnt;
        });
        return sum;
      },
      phoneNumberEntered(data) {
        this.country_code = data.countryCode;
        this.country_phone_code = data.countryCallingCode;
        this.phoneNumberIsValid =
          data.isValid && this.preferedCountries.includes(data.countryCode);
        this.num_source = data.countryCallingCode + data.nationalNumber;
        if (this.phoneNumberIsValid) {
          this.getTransactionRate(process.env.VUE_APP_MOBILE);
          this.setMeanLogo();
        }
      },
      setMeanLogo() {
        if (this.getUserMean())
          this.mean_logo = this.getUserMean()._file.replace("public", "");
        else this.mean_logo = undefined;
      },
      selectMeanType(type) {
        this.$store.dispatch("generalsettings/setManualPay", type);
        this.getTransactionRate(type);
        if (type === process.env.VUE_APP_BANQUE) {
          this.initCard();
        }
      },
      detailsAction() {
        $(".detail_paiement").slideToggle();
      },
      getCallBackUrl() {
        this.finishBtnTitle = "payments.reloading";
        let url = "";
        if (
          this.transaction._actions &&
          this.transaction._actions.callback_url
        ) {
          url =
            this.transaction._actions.callback_url +
            "?transaction_id=" +
            this.transaction._reference;
          if (url.indexOf("wwww.") !== -1) {
            url = url.replace("www.", "http://");
          }
          if (url.indexOf("http") === -1) {
            url = "http://" + url;
          }
        } else {
          url = "https://intram.org";
        }

        window.location.replace(url);
        // return  url;
      },
      pay() {
        this.submitting = true;
        let VueBox = this;
        let data = new FormData();
        data.append("first_name", this.first_name);
        data.append("last_name", this.last_name);
        data.append("transaction_id", this.transaction._id);
        if (this.manual_pay === "Mobile")
          data.append("num_source", this.num_source);
        else data.append("is_card", "true");
        data.append("country_code", this.country_code);
        data.append("fees", this.fees);
        data.append("card_number", this.card_number);
        data.append("email", this.email);
        data.append("card_cvv2", this.card_cvv2);
        if (this.manual_pay === "Mobile")
          data.append("mean_id", this.getUserMean()._id);
        this.card_expiry_month = this.card_expiration.substr(0, 2);
        this.card_expiry_year = this.card_expiration.substr(
          this.card_expiration.indexOf("/") + 1
        );
        data.append("card_expiry_month", this.card_expiry_month);
        data.append("card_expiry_year", this.card_expiry_year);

        this.$store
          .dispatch("payments/updateTransaction", data)
          .then((response) => {
            VueBox.submitted = true;
            VueBox.submitting = false;
            VueBox.status = response.status;
            if (response.error) {
              this.state = "error";
              this.errors.login = response.message;
            } else {
              if (response.card_url_payment) {
                VueBox.submitted = false;
                VueBox.card_url_payment = response.card_url_payment;
                //window.location = response.card_url_payment;
                window.open(response.card_url_payment, "_blank");
              } else {
                if (
                  VueBox.transaction.action &&
                  VueBox.transaction.action.callback_url
                ) {
                  window.location =
                    VueBox.transaction._actions.callback_url +
                    "?transaction_id=" +
                    VueBox.transaction._reference;
                } else {
                  if (window.location !== window.parent.location) {
                    $("#intramModal").css("display", "none");
                  }
                }
              }
            }
          })
          .catch((error) => {
            this.state = "error";
            this.errors.login = this.$t("payments.error_occured");
            VueBox.status = "ERROR";
          });
      },
      getItemKeyAndValue(item) {
        return { key: Object.keys(item)[0], value: Object.values(item)[0] };
      },
      resetDatas(component) {
        Object.assign(
          component.$data,
          component.$options.data.apply(component)
        );
      },
      showSnackDefault(response) {
        this.customSnack.snackbBtnColor = "black";
        if (response && response.data && response.data.error) {
          this.customSnack.snackcolor = "#d21d19";
          this.customSnack.snacktimeout = 0;
        } else {
          this.customSnack.snackcolor = "#29B3A6";
          this.customSnack.snacktimeout = 2000;
        }
        this.customSnack.text =
          response && response.data && response.data.message
            ? response.data.message
            : "";
        this.customSnack.snackbar = true;
      },
      getSetting(code) {
        if (this.generals) return this.generals[code];
      },
      formatAmount(amount) {
        return new Intl.NumberFormat().format(amount);
      },
      performReversements(type) {
        let VueBox = this;
        Swal.fire({
          icon: "warning",
          timerProgressBar: false,
          text: this.$t("reversement_warning"),
          confirmButtonText: this.$t("oui"),
          cancelButtonText: this.$t("cancel"),
          showCancelButton: true,
          cancelButtonColor: "#CCC",
          confirmButtonColor: "#29B3A6",
        }).then((result) => {
          if (result.value) {
            VueBox.reversing = true;
            VueBox.$store
              .dispatch("reversements/performReversements", type)
              .then((result) => {
                VueBox.reversing = false;
                VueBox.responseError = result.error ? "error" : "success";
                if (result.error) {
                  VueBox.responseMessage = result.message;
                } else {
                  VueBox.$store
                    .dispatch("reversements/getReversementConfigsForAdmin")
                    .then((response) => {});
                  VueBox.responseMessage =
                    VueBox.$t("reversements.total_reversemnt_done") +
                    " " +
                    result.total_reversment;
                }
              })
              .catch(() => {
                VueBox.reversing = false;
                VueBox.responseError = "error";
                VueBox.responseMessage = VueBox.$t("error_occured");
              });
          }
        });
      },
      isAdmin() {
        return this.$store.getters.auth.role._code === "admin";
      },
    },
  };
}
